import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import { appPayMethod, reCAPTCHAv3, i18n } from "commonAssets/js/constants";
import { clearMessage } from "commonAssets/lib/clearMessage";
import { localDatetime } from "commonAssets/lib/localDatetime";
import { ConfirmEmailAddress } from "commonAssets/lib/ConfirmEmailAddress";
import { dstProcess } from "commonAssets/components/FormBase/DigitalDisbursements";
import { modal } from "commonAssets/lib/modal";
import { toggleFieldError } from "commonAssets/lib/toggleFieldError";
import formDefault from "../../docs/formDefault.json";
import { mergePreservedClaimSections } from "../preserveClaimSections.js";

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
    }

    async post_claim(claim, s3env) {
        mergePreservedClaimSections(claim);
        return super.post_claim(claim, s3env);
    }

    process_claim(e, claim, deadline) {
        console.log("[customSubmitClaim:process_claim]");

        e.preventDefault();
        document.getElementById("submit-claim").disabled = true;

        if (claim.flags.sent) return;

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.init_claim_inputs();
        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById("documentation")) {
            this.process_claim_files(this.claim);
        }

        if (
            document.getElementById("email_address") &&
            document.getElementById("confirm_email_address")
        ) {
            ConfirmEmailAddress("process", this.claim);
        }

        // Enforce Option A and/or Option B selection (BE does not enforce)
        const optionASelected =
            document.querySelectorAll(
                "input[name='checkbox-option-a-contemporaneously-submitted-complaint']:checked"
            ).length > 0;
        const optionBSelected =
            document.querySelectorAll(
                "input[name='checkbox-option-b-proof-of-price-overcharge']:checked"
            ).length > 0;

        if (!optionASelected && !optionBSelected) {
            claim.flags.valid = false;
            modal(
                i18n.getTranslation("error"),
                "Please select Option A and/or Option B."
            );
        }

        // Enforce at least one uploaded supporting document
        if (document.getElementById("documentation")) {
            const fileInput = document.getElementById("file-upload");
            const existingFileCount =
                (Array.isArray(this.claim?.class_member?.claim_files)
                    ? this.claim.class_member.claim_files.length
                    : 0) ||
                (Array.isArray(this.claim?.preservedClaimSections?.files)
                    ? this.claim.preservedClaimSections.files.length
                    : 0);

            if (this.claim.uploads.length === 0 && existingFileCount === 0) {
                claim.flags.valid = false;
                if (fileInput) toggleFieldError(fileInput, true, "Required");
                modal(
                    i18n.getTranslation("error"),
                    "Supporting documentation is required for all submissions."
                );
            }
        }

        // Run DST payment validation when enabled, unless overridden
        if (appPayMethod && appPayMethod !== "") {
            claim =
                this.customDstProcess === null
                    ? dstProcess(this.claim)
                    : this.customDstProcess(this.claim);
        }

        const s3env = this.config.url;

        // Intentionally bypass shared customProcessClaim for this form

        if (claim.flags.valid) {
            grecaptcha.enterprise
                .execute(reCAPTCHAv3, { action: "submit" })
                .then((token) => {
                    claim.data.token = token;
                    this.post_claim(claim, s3env);
                });
        } else {
            document.getElementById("submit-claim").disabled = false;
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_form_errors")
            );
        }
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }
}
